module.exports = __webpack_public_path__ + "static/media/maintainance.01a9c4c2.svg";